import React, { useEffect, useState } from 'react'
import { Divider, Radio } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { GroupInfoHeader, GroupInfoInnerWrapper } from './group.styled'
import { fetchSources } from '../../apis/group'
import UserList from './UserList'
import BrandList from './BrandList'
import RoleList from './RoleList'
import GroupList from './GroupList'

function Group (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const [dataSource, setDataSource] = useState({})
  const [nowTab, setNowTab] = useState('user')
  const [brand, setBrand] = useState()
  const [group, setGroup] = useState()
  const groupDetail = user?.groups?.find(group => group.id === user?.nowGroup)

  const tabs = [
    { value: 'user', label: ln_t('group.user') },
    ...adminMode ? [{ value: 'group', label: ln_t('group.group') }] : [],
    { value: 'brand', label: ln_t('group.brand') },
    { value: 'role', label: ln_t('group.role') }
  ]
  const passProps = { adminMode, setNowTab, setBrand, brand, group, setGroup, dataSource }
  const tabComponent = {
    user: <UserList {...passProps} />,
    group: <GroupList {...passProps} />,
    brand: <BrandList {...passProps} />,
    role: <RoleList {...passProps} />
  }

  const getDataSource = async () => {
    const res = await fetchSources({ maxResults: 999 })
    if (res?.status === 200) setDataSource(res?.data?.reduce((all, val) => ({ ...all || {}, [val.id]: val.name }), {}))
  }
  useEffect(() => { getDataSource() }, [])

  const formatDate = date => dayjs(date).format('YYYY-MM-DD')
  return (
    <>
      {adminMode
        ? ''
        : <GroupInfoHeader>
            <Divider>{groupDetail?.name}</Divider>
            <GroupInfoInnerWrapper>
              <div>{ln_t('group.detail.startDate')}: {formatDate(groupDetail?.startDate)}</div>
              <div>{ln_t('group.detail.endDate')}: {formatDate(groupDetail?.endDate)}</div>
              {groupDetail?.limits && Object.keys(groupDetail?.limits)?.length
                ? <div>{ln_t('group.detail.segmentLimit')}: {groupDetail?.limits?.segmentLimit}</div>
                : ''}
              <div>{ln_t('group.detail.brandLimit')}: {groupDetail?.limits?.brandLimit}</div>
              <div>{ln_t('group.detail.userLimit')}: {groupDetail?.limits?.userLimit}</div>
              <div>{ln_t('group.detail.source')}: {groupDetail?.dataSourceTypes
                ? groupDetail?.dataSourceTypes?.split(',')?.map(i => dataSource[i])?.join(', ')
                : ln_t('group.detail.noDataSource')
                }</div>
            </GroupInfoInnerWrapper>
          </GroupInfoHeader>}
      <Radio.Group
        buttonStyle="solid"
        optionType="button"
        options={tabs}
        value={nowTab}
        onChange={e => setNowTab(e.target.value)}
        style={adminMode ? { marginBottom: '16px' } : { margin: '16px 0px' }}
      />
      {tabComponent[nowTab]}
    </>
  )
}

export default Group
